<div class="page form-page">
  <a backButton class="back-link">
    <i class="fas fa-chevron-left"></i>
    {{ 'store.products.title' | translate }}
  </a>
  <div class="form-title">
    {{ (editMode ? 'store.products.form.editTitle' : 'store.products.form.createTitle') | translate }}
  </div>
  <div class="details-container">
    <div class="sub-title">{{ 'common.details' | translate }}</div>
    <div class="two-input-container">
      <div class="label-container">{{ 'common.name' | translate }}</div>
      <div class="label-container quantity-con">{{ 'common.description' | translate }}</div>

      <div class="input-container">
        <input [(ngModel)]="product.name" type="text" [placeholder]="'store.products.form.namePlaceholder' | translate">
        <div *ngIf="isSubmitted && !product.name?.toString()?.trim()" class="error">{{ 'store.products.form.nameRequired' | translate }}
        </div>
      </div>
      <div class="input-container">
        <input [(ngModel)]="product.description" type="text" [placeholder]="'store.products.form.descriptionPlaceholder' | translate">
        <div *ngIf="isSubmitted && !product.description?.toString()?.trim()" class="error">{{ 'store.products.form.descriptionRequired' | translate }}</div>
      </div>

      <div class="label-container">{{ 'store.products.table.availableQuantity' | translate }}</div>
      <div class="label-container">{{ 'store.products.table.price' | translate }}</div>
      <div class="input-container">
        <input [(ngModel)]="product.availableQuantity" oninput="validity.valid||(value='');" min="0" type="number"
          placeholder="0">
        <div *ngIf="isSubmitted && !product.availableQuantity?.toString()?.trim()" class="error">{{ 'store.products.form.quantityRequired' | translate }}</div>
      </div>
      <div class="input-container">
        <input [(ngModel)]="product.price" min="0.0" type="number" placeholder="0.00">
        <div *ngIf="isSubmitted && !product.price?.toString()?.trim()" class="error">{{ 'store.products.form.priceRequired' | translate }}</div>
      </div>

      <div class="label-container">{{ 'store.settings.category' | translate }}</div>
      <div class="label-container"></div>
      <div class="input-container">
        <app-select style="margin-inline-start: 5px; width: 50%;" [selectedItem]="product.productCategory.id"
          [options]="categoriesList" (changeSelect)="changeFilter($event)"></app-select>
        <div *ngIf="isSubmitted && !product.productCategory.id?.toString()?.trim()" class="error">{{ 'store.products.form.categoryRequired' | translate }}</div>
      </div>
    </div>



  </div>

  <!-- Variants -->
  <div class="details-container" style="margin-top: 3%;">
    <div class="sub-title">{{ 'store.products.form.variants' | translate }}</div>

    <!-- Add new variant -->
    <div class="variant-add-container">
      <input [(ngModel)]="newVariantTitle" [placeholder]="'store.products.form.variantPlaceholder' | translate" />
      <button style="margin-top: 0;" class="btn btn-primary" (click)="addVariant()">{{ 'store.products.form.addVariant' | translate }}</button>
    </div>

    <!-- Display variants -->
    <div class="variant-list" style="width: 88%;">
      <div *ngFor="let variant of product.variants; let i = index" class="variant-item">
        <div class="variant-header">
          <span style="font-weight: 500;">{{ variant.title }}</span>
          <button class="btn btn-danger btn-sm" (click)="removeVariant(i)">{{ 'common.remove' | translate }}</button>
        </div>

        <!-- Add variant values -->
        <div class="variant-values">
          <input [(ngModel)]="newVariantValue" [placeholder]="'store.products.form.valuePlaceholder' | translate: { title: variant.title }" />
          <!-- <input [(ngModel)]="newVariantPriceModifier" type="number" step="0.01" placeholder="Price modifier (optional)" /> -->
          <button style="margin-top: 0;" class="btn btn-primary btn-sm" (click)="addVariantValue(i)">{{ 'store.products.form.addValue' | translate }}</button>
        </div>

        <!-- Display variant values -->
        <div class="variant-values-list">
          <div *ngFor="let value of variant.values; let j = index" class="variant-value-item">
            <div class="variant-value-content">
              <input type="radio" [name]="'variant_' + i" [(ngModel)]="variant.selectedValueIndex" [value]="j" />
              <span class="value-name">{{ value.value }}</span>
              <span class="price-modifier" *ngIf="value.priceModifier && value.priceModifier !== 0">
                (+{{ value.priceModifier }})
              </span>
            </div>
            <div class="variant-value-actions">
              <input type="number" step="0.01" [(ngModel)]="value.priceModifier" 
                     [placeholder]="'store.products.form.priceModifier' | translate" class="price-input" />
              <button class="btn btn-danger btn-sm" (click)="removeVariantValue(i, j)">X</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="details-container" style="margin-top: 3%; padding: 3%;">
    <div class="sub-title">{{ 'store.products.form.images' | translate }}</div>
    <div class="container my-4">
      <!-- Upload Button -->
      <div class="mb-4">
        <input type="file" id="fileInput" multiple class="d-none" (change)="onImageUpload($event)" accept="image/*" />
        <button class="btn btn-primary" (click)="triggerFileInput()">
          {{ 'store.products.form.uploadImages' | translate }}
        </button>
      </div>

      <!-- Image Gallery -->
      <div class="row g-3">
        <div *ngFor="let image of images; let i = index" class="col-sm-6 col-md-4 col-lg-3">
          <div class="card">
            <img [src]="image.imageUrl" class="card-img-top" [alt]="'store.products.form.uploadedImage' | translate" />
            <div class="card-body text-center">
              <button class="btn btn-danger btn-sm me-2" (click)="removeImage(i)">
                {{ 'common.remove' | translate }}
              </button>
              <button class="btn btn-warning btn-sm" (click)="setAsDefault(i)" [disabled]="image.isDefault">
                {{ (image.isDefault ? 'store.products.form.default' : 'store.products.form.setDefault') | translate }}
              </button>
            </div>
            <div *ngIf="image.isDefault" class="badge bg-success position-absolute top-0 start-0 m-2">
              {{ 'store.products.form.default' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>

  <div class="btns-last">
    <button class="cancel" backButton>{{ 'common.cancel' | translate }}</button>
    <button class="save" (click)="SaveProduct()">{{ (editMode ? 'common.saveChanges' : 'store.products.form.publish') | translate }}</button>
  </div>
</div>
<ngx-spinner color="rgba(30, 205, 100, 1)" type="ball-scale-multiple"></ngx-spinner>